import { render } from "./about-us.vue?vue&type=template&id=0810de96&scoped=true"
import script from "./about-us.vue?vue&type=script&lang=js"
export * from "./about-us.vue?vue&type=script&lang=js"

import "./about-us.vue?vue&type=style&index=0&id=0810de96&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0810de96"]])

export default __exports__